// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Account: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 12 14">
            <path
                fill="currentColor"
                d="M6,7 C7.22491019,7 8.35677501,6.33290362 8.96923011,5.25 C9.5816852,4.16709638 9.5816852,2.83290362 8.96923011,1.75 C8.35677501,0.667096376 7.22491019,0 6,0 C4.7750894,0 3.6432254,0.667096376 3.03076989,1.75 C2.41831439,2.83290362 2.41831439,4.16709638 3.03076989,5.25 C3.6432254,6.33290362 4.7750894,7 6,7 Z M12,14 L10.2857143,8.3125 L1.71428571,8.3125 L0,14 L12,14 Z"
            />
        </svg>
    );
};

export default React.memo(Account);
